import styled from 'styled-components';
import { EmptyImage } from '.';
import { useVideoUpload } from 'pages/ListerVehicleUploadV2/CameraView/hooks/useVideoUpload';
import { useHiddenUpload } from 'hooks/useHiddenUpload';

const Wrapper = styled.div``;

export const EmptyVideoComponent = () => {
  const { inputProps, openFileInput } = useHiddenUpload({ multiple: false, accept: 'video/mp4,video/x-m4v,video/*' });

  const uploadVideo = useVideoUpload('exterior.subsections.exterior');

  const onFileSelected: React.ChangeEventHandler<HTMLInputElement> = e => {
    const files = e.target.files ? Array.from(e.target.files) : [];
    if (files.length === 0) return;
    console.log(files, 'video files');
    uploadVideo(files);
  };

  return (
    <>
      <Wrapper onClick={openFileInput}>
        <EmptyImage type="video" />
      </Wrapper>
      <input onChange={onFileSelected} {...inputProps} />
    </>
  );
};
